'use strict';

angular.module('billings').controller('SubscriptionController', ['$rootScope','$scope', '$stateParams', '$location', 'SubscriptionMain', 'Authentication', 'Subscription', 'Utilities', 'SweetAlert', 'Billings',
  function($rootScope, $scope, $stateParams, $location, SubscriptionMain, Authentication, Subscription, Utilities, SweetAlert, Billings) {

    $scope.authentication = Authentication;
    $scope.planId = '';
    $scope.notAllowedPlans = [];
    $scope.additionalTeamMembersStarter = 0;
    $scope.additionalTeamMembersPro = 0;
    $scope.additionalTeamMembersGrowth = 0;
		// Select pricing controller logic
		// ...

		$scope.processing = false;

		$scope.billingDataEntered = false;
		if ($scope.authentication.user && $scope.authentication.user._billing) {
			$scope.billingDataEntered = $scope.authentication.user._billing.billingDataEntered;
		}

    $scope.success = $scope.error = null;
    $scope.init = function(){
      $scope.planId = '';
      Billings.get({
        billingId : $stateParams.billingId
      },function success(response){
        $scope.billing = response;
        $scope.planId = response.planId.toLowerCase();
        // Do not allow the current plan to be selected
        if ($scope.notAllowedPlans.indexOf($scope.planId) === -1) {
          $scope.notAllowedPlans.push($scope.planId);
        }
      });

			// Get all the plans the user is not allowed to select because
			// he would exceed the limits of it
			SubscriptionMain.getSubscriptionPlansAllowed(function(err, allowedPlans) {
				for (var planId in allowedPlans) {
					if (allowedPlans[planId] === false && $scope.notAllowedPlans.indexOf(planId) === -1) {
						$scope.notAllowedPlans.push(planId);
					}
				}
			});
    };

    $scope.subscribe = function() {
			$scope.processing = true;
			$scope.success = $scope.error = null;
      var additionalTeamMembers = 0;

      if($scope.planId === 'Starter')
      {
        additionalTeamMembers = $scope.additionalTeamMembersStarter;
      }
      else if($scope.planId === 'Pro')
      {
        additionalTeamMembers = $scope.additionalTeamMembersPro;
      }
      else if($scope.planId === 'Growth')
      {
        additionalTeamMembers = $scope.additionalTeamMembersGrowth;
      }

      var subscription = new Subscription ({
        planId: $scope.planId,
        additionalTeamMembers: additionalTeamMembers
      });

      // Redirect after save
      subscription.$save(function(response) {
        $scope.success = true;

        $rootScope.$broadcast('RefreshSignupStatus', null);
        SweetAlert.swal({title: 'Subscribed!', text: '', type: 'success'},
          function () {}
        );

        $location.path('billings');
      }, function(errorResponse) {
				$scope.processing = false;
				$scope.error = errorResponse.data.message;
      });
    };

    $scope.updateSubscribe = function() {
		  if ($scope.notAllowedPlans.indexOf($scope.planId) !== -1) {
			  // Make first sure that the plan the user has choosen does not
			  // exceed his current usage
			  Utilities.showMessage(
				  'Subscription not changed!',
				  'You can not switch to the selected plan because you are over its limits. Please select a higher plan or contact <a href="mailto:info@applanga.com">info@applanga.com</a>',
				  'error'
			  );
			  return;
		  }

      $scope.processing = true;

      $scope.success = $scope.error = null;

		  SubscriptionMain.upgradeSubscription($scope.planId, function(err, result) {
			  if (err) {
				  $scope.processing = false;
				  $scope.error = err.data.message;
				  return;
			  }

			  $scope.success = true;

			  Utilities.showMessage(
				  'Success!',
				  'You got successfully upgraded to a new plan!',
				  'success'
			  );

			  $location.path('billings');
		  });

    };
	}
]);
